import React from 'react';
import Card from 'SharedComponents/Card';
import BotSelectorBox from './Shared/BotSelectorBox';
import { riskLevels, colors, botClassificationName } from "components/AFP/Constants";



const BlockedBotTypeBreakdownCards = (props) => {
    const {botTypesToShow, setBotTypesToShow, setLoading} = props;  
    
    const formatBotBreakdownData = () => {
        const data = JSON.parse(JSON.stringify(Object.values(props.websiteThreatAssessment?.item ?? {})));
        for (let keys in data) {
            for (let val in riskLevels) {
                if (riskLevels[val] === data[keys].bot_risk_type) {
                    data[keys].bot_risk_type = val;
                }
            }
        };
        return data.sort((a, b) => Number(b.bot_risk_type) - Number(a.bot_risk_type));
    };
    const botBreakdownData = formatBotBreakdownData();

    const totalBotsLandings = Object.values(props.websiteThreatAssessment?.item ?? [])?.reduce((acc, item) => {
        return acc += parseInt(item?.total_landings)
    }, 0);


    //Initial Render UseEffect
    React.useEffect(() => {
        //Get all bot types from the websiteThreatAssessment
        if(botTypesToShow.size === 0) {
            setBotTypesToShow(new Map(Object.values(props.websiteThreatAssessment?.item ?? {}).map(item => [item.bot_classification, true])));
        };       
    }, []);


console.log("botTypesToShow type: ", typeof botTypesToShow, "botTypesToShow: ", botTypesToShow);


    return (
        <div>
            <h3>Detected Bots Type Breakdown</h3>
            <div className="reporting-horizontal-card-container">
                {
                    botBreakdownData?.map((item, index) => {
                        if (botTypesToShow.get(item.bot_classification)) {
                            return (<Card color={colors[item.bot_risk_type]} backgroundColor='#F4F4F4' key={index}>
                                <>
                                    <div style={{ background: colors[item.bot_risk_type] }} className='bot-title'>{item.bot_classification}</div>
                                    <div className='bot-spec'>
                                        <div className='bot-total-value'>{item.total_landings}</div>
                                        <div className='bot-percentage'>{((item?.total_landings / totalBotsLandings) * 100).toFixed(1)}%</div>
                                        <div className='targeted-bots'>Most targeted page:</div>
                                        <div className='bots-url'>{decodeURIComponent(item.most_popular_landing_page)}</div>
                                    </div>
                                    <div className='bot-dangerous-level' style={{ background: colors[item.bot_risk_type] }}>{riskLevels[item.bot_risk_type]}</div>
                                </>
                            </Card>)
                        }

                    })
                }
                
            </div>
        </div>
    );
};

export default BlockedBotTypeBreakdownCards;
